const subsystems = {
  bindings: {
    train: '<',
  },
  templateUrl: '/modules/gridlets/dashboard/train-health-gridlet/subsystems/subsystems.html',
  controller: 'SubsystemsController',
};

angular
  .module('dashboardGridletDirectives')
  .component('subsystems', subsystems);
